import "./js/ezwebplayer.js";
